module.exports = __webpack_public_path__ + "fonts/d48525bb5f59093d8f177569f5af6dfb.txt";